import React, { useState } from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import useTranslation from '../../../../../Hooks/useTranslation';
import Loading from '../../../../../Components/Loading';
import useTermItemSelect from '../../../../Term/hooks/useTermItemSelect';
import { useEffectAsync } from '../../../../../helpers';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
}

const P1PaymentCoverageType: React.FC<Props> = ({ onChange, value }) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [options, setOptions] = useState<SelectValue[]>([]);

	const { termItemSelectOptions } = useTermItemSelect({
		termType: 'p1_payment_coverage_type',
		take: 999,
		labelTransform: item => {
			return item.value!;
		},
		useValue: true,
	});

	useEffectAsync(async () => {
		setIsLoading(true);
		setOptions(await termItemSelectOptions());
		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={value}
		/>
	);
};
export default P1PaymentCoverageType;
